import {Box, SelectInput} from 'exsportia-components'
import {useFormikContext} from 'formik'
import React, {FC, useCallback, useMemo} from 'react'

import {useSubscriptionBooking} from '../../../api/subscription-bookings/hooks'
import {useSubscription} from '../../../api/subscriptions/hooks'
import {SubscriptionPriceTypesEnum} from '../../../api/subscriptions/types'
import {useVenue} from '../../../api/venue/hooks'
import {PaySubscriptionCycleFormType} from '../../../services/subscription-bookings/forms/pay-subscription-cycles-form'
import {TitledSection} from '../../../ui/components/titeled-section/titled-section'
import {useLocale} from '../../../utils/i18n'
import {isNotNilAndNotEmpty} from '../../../utils/logic'
import {
  CycleOption,
  subscriptionPlansToSelectOptions,
} from '../../subscription-profile/helpers'

type CyclesByTypeMap = {[key in CycleOption['type']]: CycleOption}

export const PaySubscriptionBookingInstallmentsOptions: FC = () => {
  const {l} = useLocale()
  const {setFieldValue, values} = useFormikContext<PaySubscriptionCycleFormType>()
  const {data: subscription} = useSubscription(values.subscriptionBooking?.membershipId)
  const {data: subscriptionBooking} = useSubscriptionBooking(values.subscriptionBooking?.uid)
  const {data: venue} = useVenue()
  const cyclesConfig = useMemo(() => {
    if (isNotNilAndNotEmpty(subscription) && venue?.currency) {
      return subscriptionPlansToSelectOptions({
        currency: venue.currency,
        subscription,
        timeZone: 'Israel',
      })
    }
    return []
  }, [subscription, venue])

  const cyclesMapByType = useMemo(
    () => cyclesConfig.reduce((acc, cycle) => ({
        ...acc,
        [cycle.type]: cycle
      }
      // eslint-disable-next-line @typescript-eslint/prefer-reduce-type-parameter
    ), {} as CyclesByTypeMap), [cyclesConfig])

  const selectedOption = useMemo(
    () => {
      if (!subscriptionBooking) {
        return null
      }
      return cyclesMapByType[subscriptionBooking.priceTime as SubscriptionPriceTypesEnum]
    },
    [values]
  )

  const setInstallmentOption = useCallback((value: never) => { // TODO: select input types unsafe
    setFieldValue('installmentOption', value).catch(e => console.log(String(e)))
  }, [selectedOption?.installmentsOptions])

  if (Number(selectedOption?.installmentsOptions.length) <= 1) {
    return null
  }

  return (
    <Box mt={'12px'}>
      <TitledSection title={l('installments')}>
        <SelectInput
          name='installmentOption'
          isSearchable={false}
          options={selectedOption?.installmentsOptions}
          onChange={setInstallmentOption}
          value={values.installmentOption}
          settings={{
            // eslint-disable-next-line
            container: (provide: any) => ({ // TODO: select input type unsafe
              ...provide,
              width: '100%',
            }),
          }} />
      </TitledSection>
    </Box>
  )
}
